import { VStack, HStack } from '@chakra-ui/react';
import { IconButton } from 'Atoms';
import { TimePeriods, TimePeriodsEnums } from 'containers/Esrs/pieces';
import { Typography } from 'Tokens';
import { HelpIcon } from 'Tokens/Icons/Status';
import {
  GroupOrderOptions,
  GroupOrderSelector,
  QuarterSelector,
} from '../../AggregatedMetrics/AggregatedMetricsUtils';
import { SelectedMetric } from 'containers/Esrs';
import { TaskFilter, TaskFilterOptions } from '../../MetricsTable/MetricsTable.utils';

export const MetricsHeader = ({
  groupOrOrder,
  setGroupOrOrder,
  taskFilterOption,
  setTaskFilter,
  areMetricsYearly,
  selectedQuarter,
  selectedUserId,
  setSelectedUserId,
  setSelectedQuarter,
  setSelectedMetric,
  onDrawerOpen,
  drTitle,
  drRef,
  drDescription,
  selectedAdditionalTypes,
  setSelectedAdditionalTypes,
  selectedMaterialityOptions,
  setSelectedMaterialityOptions,
  additionalTypesOptions,
  materialityFilterOptions,
}: {
  taskFilterOption: TaskFilterOptions;
  setTaskFilter: (val: TaskFilterOptions) => void;
  groupOrOrder: GroupOrderOptions;
  setGroupOrOrder: (val: GroupOrderOptions) => void;
  areMetricsYearly: boolean;
  selectedQuarter: TimePeriods;
  selectedUserId: string;
  setSelectedUserId: (val: string) => void;
  setSelectedQuarter: (val: TimePeriodsEnums) => void;
  onDrawerOpen: () => void;
  setSelectedMetric: (value: React.SetStateAction<SelectedMetric | undefined>) => void;
  drTitle: string;
  drRef: string;
  drDescription: string;
  selectedAdditionalTypes: string[];
  setSelectedAdditionalTypes: (val: string[]) => void;
  selectedMaterialityOptions?: string[];
  setSelectedMaterialityOptions?: (val: string[]) => void;
  additionalTypesOptions: {
    label: string;
    ref: string;
  }[];
  materialityFilterOptions: {
    ref: string;
    label: string;
    disabled: boolean;
  }[];
}) => {
  return (
    <VStack spacing="8px" alignItems="start" w="100%">
      <HStack w="100%" justifyContent="space-between">
        <HStack spacing="6px" alignItems="center" justifyContent="space-between" w="100%">
          <Typography variant="h3" as="span">
            Data points
          </Typography>
          <HStack justifyContent="flex-end">
            <TaskFilter
              setTaskFilter={setTaskFilter}
              taskFilterOption={taskFilterOption}
              selectedUserId={selectedUserId}
              setSelectedUserId={setSelectedUserId}
              additionalTypesOptions={additionalTypesOptions}
              selectedAdditionalTypes={selectedAdditionalTypes}
              setSelectedAdditionalTypes={setSelectedAdditionalTypes}
              materialityFilterOptions={materialityFilterOptions}
              setSelectedMaterialityOptions={setSelectedMaterialityOptions}
              selectedMaterialityOptions={selectedMaterialityOptions}
            />
            <GroupOrderSelector groupOrOrder={groupOrOrder} setGroupOrOrder={setGroupOrOrder} />
            {!areMetricsYearly && (
              <QuarterSelector
                defaultQuarter={selectedQuarter as TimePeriodsEnums}
                setSelectedQuarter={setSelectedQuarter}
              />
            )}
            <IconButton
              aria-label="learn more"
              variant="ghost"
              icon={<HelpIcon />}
              size="sm"
              onClick={() => {
                setSelectedMetric({
                  reference: drRef,
                  title: drTitle,
                  description: drDescription ?? '',
                  isDisclosure: true,
                });
                onDrawerOpen();
              }}
            />
          </HStack>
        </HStack>
      </HStack>
    </VStack>
  );
};
